import { API_BASE_URL, CDN_BASE_URL } from ".";

const ADMIN = `${API_BASE_URL}/app/admin`;
const APP = `${API_BASE_URL}/app/app`;

const ENDPOINTS = {
  appointment: `${ADMIN}/appointments`,
  app: {
    auth: `${APP}/auth`,
    media: `${APP}/medias`,
    public: `${APP}/public`,
  },
  booking: {
    driver: `${ADMIN}/booking/drivers`,
    hotel: `${ADMIN}/booking/hotels`,
    place: `${ADMIN}/booking/places`,
    reservation: `${ADMIN}/booking/reservations`,
    transfer: `${ADMIN}/booking/transfers`,
  },
  call: `${ADMIN}/calls`,
  calendar: `${ADMIN}/calendar`,
  callerID: `${ADMIN}/caller-ids`,
  category: `${ADMIN}/categories`,
  cdn: CDN_BASE_URL,
  clinic: `${ADMIN}/clinics`,
  company: `${ADMIN}/companies`,
  contact: `${ADMIN}/contacts`,
  action: `${ADMIN}/actions`,
  conversion: `${ADMIN}/conversions`,
  list: `${ADMIN}/lists`,
  csv: `${ADMIN}/csv`,
  domain: `${ADMIN}/domains`,
  duty: `${ADMIN}/duties`,
  email: `${ADMIN}/emails`,
  facebook: {
    authorize: `${ADMIN}/facebook/authorize`,
    forms: `${ADMIN}/facebook/forms`,
    pages: `${ADMIN}/facebook/pages`,
  },
  field: `${ADMIN}/fields`,
  files: `${ADMIN}/files`,
  finance: `${ADMIN}/finance`,
  form: `${ADMIN}/forms`,
  group: `${ADMIN}/groups`,
  hook: `${ADMIN}/hooks`,
  instruction: `${ADMIN}/instructions`,
  integration: {
    alotech: `${ADMIN}/integrations/alotech`,
    facebook: `${ADMIN}/integrations/facebook`,
    gateway: `${ADMIN}/integrations/gateways`,
    gmail: `${ADMIN}/integrations/gmail`,
    kobikom: `${ADMIN}/integrations/kobikom`,
    simai: `${ADMIN}/integrations/simai`,
    telnyx: `${ADMIN}/integrations/telnyx`,
    twilio: `${ADMIN}/integrations/twilio`,
    whatsapp: `${ADMIN}/integrations/whatsapp`,
  },
  invoice: `${ADMIN}/invoices`,
  key: `${ADMIN}/keys`,
  label: `${ADMIN}/labels`,
  lead: `${ADMIN}/leads`,
  level: `${ADMIN}/levels`,
  log: {
    access: `${ADMIN}/logs/access`,
    call: `${ADMIN}/logs/call`,
    facebook: `${ADMIN}/logs/facebook`,
    sms: `${ADMIN}/logs/sms`,
    whatsapp: `${ADMIN}/logs/whatsapp`,
  },
  map: `${ADMIN}/maps`,
  match: `${ADMIN}/matches`,
  media: `${ADMIN}/medias`,
  mediaTag: `${ADMIN}/media-tags`,
  message: `${ADMIN}/messages`,
  messageTemplate: `${ADMIN}/message-templates`,
  metric: `${ADMIN}/metrics`,
  misc: `${ADMIN}/misc`,
  note: `${ADMIN}/notes`,
  notification: `${ADMIN}/notifications`,
  number: `${ADMIN}/numaras`,
  operation: `${ADMIN}/operations`,
  permisson: `${ADMIN}/permissions`,
  phone: `${ADMIN}/phones`,
  profiler: `${ADMIN}/profilers`,
  publication: {
    document: `${ADMIN}/publications/documents`,
    template: `${ADMIN}/publications/templates`,
    verify: `${ADMIN}/publications/verify`,
  },
  rate: `${ADMIN}/rates`,
  report: `${ADMIN}/reports`,
  resource: `${ADMIN}/resources`,
  role: `${ADMIN}/roles`,
  schedule: `${ADMIN}/schedules`,
  source: `${ADMIN}/sources`,
  staff: `${ADMIN}/staffs`,
  stats: {
    company: `${ADMIN}/stats/company`,
  },
  tag: `${ADMIN}/tags`,
  task: `${ADMIN}/tasks`,
  tax: `${ADMIN}/taxs`,
  timeline: `${ADMIN}/timelines`,
  timelineTemplate: `${ADMIN}/timeline-templates`,
  translation: `${ADMIN}/translations`,
  treatment: `${ADMIN}/treatments`,
  twilio: `${ADMIN}/twilio`,
  user: `${ADMIN}/users`,
  WPage: `${ADMIN}/web-pages`,
  whois: `${ADMIN}/whois`,
};

export default ENDPOINTS;
